import * as React from 'react';
import { ModulesBasic, IPropsBasic, ModulesRoot } from 'kts-scaffold-framework/modules';
import { connect, Verification } from 'kts-platform-frame/redux';
import ReduxState, { } from 'kts-platform-frame/redux/ReduxState';
import { appStore } from 'kts-platform-frame/api';
import { RightPopUps } from 'kts-platform-frame/display/part';
import ModulesState from './Modules.State';
import ModulesAction from './Modules.Action';
import modulesRoute from './Modules.Route';
import { IApp } from 'kts-platform-frame/redux/reducers/config/INode';
import { message, Icon } from 'antd';
import { remindCheck } from 'src/api';
import AppSdk from 'kts-platform-frame/appSdk';
import { SdkConfig } from 'kts-components';

const css = require('./index.scss');
let tip;

SdkConfig.instance.sdk = AppSdk;

/** 全局数据片段数据接口 */
interface IReduxStatePart {
    appMap?: Map<string, IApp>;
    version: '0.2' | '0.3';
}

/** 组建的props接口 */
interface IProps extends IReduxStatePart, IPropsBasic {
}

/** 绑定全局数据到props */
@connect((state: ReduxState): IReduxStatePart => ({
    appMap: state.config.appList.map,
    version: state.system.version,
}))
export default class Home extends ModulesBasic<IProps, ModulesState> {

    /** 组建状态 */
    public state: ModulesState = new ModulesState();
    timer: number;
    tipId: number = -1;
    //间隔时间
    count = 300000;
    /** 构造函数 */
    constructor(props: IProps) {
        super(props, ModulesAction);
    }

    componentDidMount() {
        // SdkConfig.instance.setSdk(()=>AppSdk.instance);
        this.verifyPermissions();
        this.tipCheck();
        this.timer = window.setInterval(this.tipCheck, this.count);
    }
    componentWillUnmount() {
        this.clearTime();
    }
    clearTime() {
        if (this.timer) {
            window.clearInterval(this.timer);
        }
    }
    tipCheck = () => {
        tip = window.localStorage.getItem('kts-tiplog');
        this.getRemoteTip();
    }
    onCloseTip = () => {
        message.destroy();
    }
    showMessage = (data) => {
        if (data.id !== this.tipId) {
            this.tipId = data.id;
            message.info(<span style={{ wordBreak: 'break-all' }}>{data.remindContent}<a onClick={() => { this.neverAagin(data); }} style={{ paddingLeft: 10, paddingRight: 10 }}>不再提醒</a><Icon style={{ color: 'rgba(0,0,0,.65)' }} onClick={this.onCloseTip} type="close" /></span>, 0);
        }
    }
    getRemoteTip = async () => {
        const res = await remindCheck(this) as any;
        let data = res.res;
        if (!res.er && data) {
            this.clearTime();
            data = { ...data, close: '0' };
            if (tip) {
                tip = JSON.parse(tip);

                //显示新的提示内容
                if (tip.id !== data.id) {
                    this.saveTip(JSON.stringify(data));
                    this.showMessage(data);
                } else {
                    const now = new Date().getTime();
                    const updateStart = new Date(tip.remindStartTime).getTime();
                    const updateEnd = new Date(tip.remindEndTime).getTime();
                    const close = tip.close;

                    if (updateStart < now && now < updateEnd && close === '0') {
                        this.showMessage(data);
                    } 

                }
            } else {
                this.saveTip(JSON.stringify(data));
                this.showMessage(data);
            }
        }
    }
    neverAagin = (data) => {
        data = {
            ...data,
            close: '1'
        };
        message.destroy();
        this.saveTip(JSON.stringify(data));
    }
    saveTip = (data) => {
        window.localStorage.setItem('kts-tiplog', data);
    }
    componentDidUpdate() {
        this.verifyPermissions();
    }

    // 这里尽量只调用UI组件
    render() {
        return (
            <ModulesRoot action={ModulesAction}>

                {/* 右侧弹出窗口 */}
                <RightPopUps />

                <div className={css.modules}>
                    {modulesRoute(this.props.version)}
                </div>
            </ModulesRoot>
        );
    }

    /** 等不急 */
    private verifyPermissions = async () => {
        const appKey = this.inquiryApp(window.location.pathname);
        if (!appKey) {
            return;
        }

        const queryAppInfo = await appStore.queryAppInfo(null, { appKey });
        if (queryAppInfo.er) {
            if (queryAppInfo.er.body.status.returnCode !== '02001') {
                let twoFactorAuth = queryAppInfo.er.body.status.returnCode === '54099' ? '/twoFactorAuth' : '';
                this.props.history.push('/workbench/app/error' + twoFactorAuth);
            }
            return;
        }
    }

    /** 通过 pathname 查询app key */
    private inquiryApp = (pathname: string): string => {
        let key: string = null;
        this.props.appMap.forEach((e, k) => {
            if (pathname.indexOf(e.URL) === 0) {
                key = k;
            }
        });
        return key;
    }
}

Verification.instance.start();


// WEBPACK FOOTER //
// ./src/display/modules/Home/index.tsx